import httpService from "../../components/service";

export const status = {
    namespaced: true,
    state: {
        listStatus: []
    },
    getters: {
        getStatusColor() {
            return status => {
                let color = null;
                switch (status.toLowerCase()) {
                    case "in_progress":
                        color = "#4CB4D3";
                        break;
                    case "new":
                        color = "#D64C56";
                        break;
                    case "cancelled":
                        color = "#878787";
                        break;
                    case "obsolete":
                        color = "#C6C4CC";
                        break;
                    case "active":
                        color = "#98BC64";
                        break;
                    default:
                        color = "blue";
                        break;
                }
                return color;
            };
        }
    },
    mutations: {
        SET_LIST_STATUS: (state, list) => {
            state.listStatus = list;
        }
    },
    actions: {
        async getListStatus(context) {
            const res = await httpService.get("/components_all_status");
            if (res.code) throw Error(res.message);
            context.commit("SET_LIST_STATUS", res);
            return res;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/module/status.js